import * as Yup from 'yup';

interface IErrors {
  maxLength: string,
  minLength: string,
}

function validationSchema(errors: IErrors, minLength: number, maxLength: number) {
  return Yup.object().shape({
    name: Yup.string()
      .nullable()
      .notRequired()
      .test('min', errors.minLength.replace('{min}', `${minLength}`), (value: string | null | undefined) => {
        if (!value) {
          return true
        } else {
          return value.length >= minLength
        }
      })
      .test('max', errors.maxLength.replace('{max}', `${maxLength}`), (value: string | null | undefined) => {
        if (!value) {
          return true
        } else {
          return value.length <= maxLength
        }
      })
      /*.when('name', {
        is: (value: string) => !!value,
        then: (schema) => schema
          .min(minLength, errors.minLength.replace('{min}', `${minLength}`))
          .max(maxLength, errors.maxLength.replace('{max}', `${maxLength}`)),
      }),*/
  });
}

export const validationTextFieldMinMax = (val: any, minLength: number, maxLength: number, errors: IErrors) => {
  const value = { name: val };

  const schema = validationSchema(errors, minLength, maxLength);

  try {
    schema.validateSync(value, { abortEarly: false });
    return undefined;
  } catch (error: any) {
    return error.inner[0].errors[0];
  }
};
